import { PageId } from 'constants/pages'
import type { TStep } from 'src/types'

export const STEPS_INTL_1: TStep[] = [
  {
    pageId: PageId.ANALYZING,
  },
  {
    pageId: PageId.START,
  },
  {
    pageId: PageId.QUESTION_1,
  },
  {
    pageId: PageId.QUESTION_2,
  },
  {
    pageId: PageId.QUESTION_3,
  },
  {
    pageId: PageId.QUESTION_4,
  },
  {
    pageId: PageId.SPEED_FEEDBACK,
  },
  {
    pageId: PageId.QUESTION_5,
  },
  {
    pageId: PageId.QUESTION_6,
  },
  {
    pageId: PageId.QUESTION_7,
  },
  {
    pageId: PageId.QUESTION_8,
  },
  {
    pageId: PageId.QUESTION_9,
  },
  {
    pageId: PageId.QUESTION_10,
  },
  {
    pageId: PageId.QUESTION_11,
  },
  {
    pageId: PageId.QUESTION_12,
  },
  {
    pageId: PageId.SMARTNESS_FEEDBACK,
  },
  {
    pageId: PageId.QUESTION_13,
  },
  {
    pageId: PageId.QUESTION_14,
  },
  {
    pageId: PageId.QUESTION_15,
  },
  {
    pageId: PageId.QUESTION_16,
  },
  {
    pageId: PageId.QUESTION_17,
  },
  {
    pageId: PageId.QUESTION_18,
  },
  {
    pageId: PageId.QUESTION_19,
  },
  {
    pageId: PageId.QUESTION_20,
  },
  {
    pageId: PageId.LOGICAL_SKILLS_FEEDBACK,
  },
  {
    pageId: PageId.QUESTION_21,
  },
  {
    pageId: PageId.QUESTION_22,
  },
  {
    pageId: PageId.QUESTION_23,
  },
  {
    pageId: PageId.QUESTION_24,
  },
  {
    pageId: PageId.QUESTION_25,
  },
  {
    pageId: PageId.AGE_QUESTION,
  },
  {
    pageId: PageId.EDUCATION_QUESTION,
  },
  {
    pageId: PageId.DISCOVER_FEEDBACKS,
  },
  {
    pageId: PageId.PREPARE_FLOW,
  },
  {
    pageId: PageId.EMAIL,
  },
  {
    pageId: PageId.OFFER,
  },
  {
    pageId: PageId.PAYMENT,
  },
  {
    pageId: PageId.REGISTRATION,
  },
  {
    pageId: PageId.NAME_ENTRY,
  },
  {
    pageId: PageId.CERTIFICATE,
  },
  {
    pageId: PageId.REPORT,
  },
]
